// components/ScrollToTop.jsx
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

function resetWindowScroll() {
  window.scrollTo(0, 0);
  if (document.documentElement) document.documentElement.scrollTop = 0;
  if (document.body) document.body.scrollTop = 0;
}

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    // Disable browser auto-restore
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      let tries = 0;
      const scrollToHash = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ block: "start", inline: "nearest" });
        } else if (tries < 10) {
          tries += 1;
          setTimeout(scrollToHash, 50); // wait for content to mount
        } else {
          resetWindowScroll();
        }
      };
      scrollToHash();
    } else {
      resetWindowScroll();
      // Re-assert after paint — short pages can leave you mid-footer if the
      // previous route was tall and the browser restores scroll late.
      requestAnimationFrame(() => {
        resetWindowScroll();
        requestAnimationFrame(resetWindowScroll);
      });
    }
  }, [pathname, hash]);

  return null;
}
